import { CellContext, RowData, flexRender } from '@tanstack/react-table';
import { MAGNETIC_TOKENS, css } from '@appd/uik';

const { TYPOGRAPHY } = MAGNETIC_TOKENS;

// use Tailwind for static styling, use inline style for dynamic styling
const STYLES = {
  CELL: css.Styles({
    textOverflow: 'ellipsis',
    overflowWrap: 'break-word',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    verticalAlign: 'middle',
    fontFamily: TYPOGRAPHY.P3_DEFAULT,
  }),
};

export const TableCell = <TData extends RowData, TValue>({ cell }: CellContext<TData, TValue>): JSX.Element => {
  return (
    <td
      data-field={cell.column.id}
      className="flex-1 border-b border-solid border-control-border-weak"
      style={{
        ...STYLES.CELL,
        ...{ width: cell.column.getSize(), textAlign: cell.column.columnDef.meta?.align },
      }}
    >
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </td>
  );
};
